export default __webpack_public_path__ + "static/media/profile.fdb2f362.svg";